import { RECEIVED_UPLOAD } from "types/actions/upload"

const isLoadingInitialState = {
  file: "",
  uploadType: ""
}

export default (state = isLoadingInitialState, action) => {
  switch (action.type) {
    case RECEIVED_UPLOAD:
      return {
        ...state,
        file: action.file,
        uploadType: action.uploadType
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/upload.js